import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import React from 'react';

type Props = {
  title: string;
  lead?: string;
  mainParagraph: string;
  secondParagraph: string;
  thirdParagraph: string;
  lastParagraph?: string;
  isReverse?: boolean;
  id?: string;
};

const FullTextSection = ({
  title,
  lead,
  lastParagraph,
  mainParagraph,
  secondParagraph,
  thirdParagraph,
  isReverse,
  id,
}: Props) => (
  <section id={id} className="boxed-container">
    <Box
      mb={28}
      pe={[4, null, null, isReverse ? 0 : `30%`]}
      ps={[4, null, null, !isReverse ? 0 : `30%`]}
      maxWidth={[`full`, null, `md`, `inherit`]}
      mx="auto"
    >
      {lead && (
        <Text
          fontWeight="bold"
          mb={1}
          fontSize={[`md`, null, `xl`]}
          color="brand.400"
        >
          {lead}
        </Text>
      )}
      <Heading whiteSpace="pre-line" mb="9" as="h2" size="2xl">
        {title}
      </Heading>
      <Text mb={9} fontSize={[`lg`, null, null, `2xl`]} lineHeight={2.1}>
        {mainParagraph}
      </Text>
      <Flex direction={[`column`, null, null, `row`]}>
        <Text lineHeight={1.9} me={[null, null, null, 12]}>
          {secondParagraph}
        </Text>
        <Box lineHeight={1.9} mt={[4, null, null, 0]}>
          <Text>{thirdParagraph}</Text>
          {lastParagraph && (
            <Box pt={9} fontSize="2xl" lineHeight={1.2}>
              {lastParagraph}
            </Box>
          )}
        </Box>
      </Flex>
    </Box>
  </section>
);

export default FullTextSection;
